import React from 'react';
import { GetServerSideProps } from 'next';
import getConfig from 'next/config';
import BasicLayout from 'layout/Basic';
import CategoryPage from 'containers/Category';
import { convertProps } from 'lib/parseAPIResponse';
import { NextSeo } from 'next-seo';

export const category = (props) => {
    const { url } = getConfig().publicRuntimeConfig;
    return (
        <BasicLayout ads={props.ads}>
            <NextSeo
                title={`${props.category.title}`}
                canonical={`${url}/${props.category.seoSlug}`}
            />
            <CategoryPage {...props} />
        </BasicLayout>
    );
};

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
    const { apiUrl } = getConfig().publicRuntimeConfig;
    if (!params.slug) {
        return {
            notFound: true
        };
    }
    const path = `/public/api/categories/${params.slug}`;
    return Promise.all([
        fetch(apiUrl + path),
        fetch(`${apiUrl}/public/api/naszadsik?path=${params.slug}`)
    ]).then(async ([res1, res2]) => {
        const data = await res1.json();
        if (data.code === 404) {
            return {
                notFound: true
            };
        }
        const ads = await res2.json();

        return { props: { ...convertProps(ads), ...convertProps(data) } };
    });
};

export default category;
